import { SAVE_LAST_QUERY } from '../type';

export function lastQueryReducer(state = '', action) {
  const { type, payload } = action;

  switch (type) {
    case SAVE_LAST_QUERY: {
      return payload;
    }
    default:
      return state;
  }
}
